// edunix
// export const logo = require('@/assets/edunix-white.png')
// export const schoolFacebookPage = 'https://www.facebook.com/edunix.system'
// export const colors = {
//     primary: '#295487',
//     secondary: '#f75e35'
// }

// motherLand
// export const logo = require('@/assets/img_app_logo.png')
// export const whiteLogo = require('@/assets/img_app_logo-white.png')
// export const schoolFacebookPage = 'https://www.facebook.com/profile.php?id=100063896384736'
// export const colors = {
//     primary: '#00a191',
//     secondary: '#046b5e'
// }

// road alkbal
// export const logo = require('@/assets/roadalmustakbal.png')
// export const whiteLogo = require('@/assets/roadalmustakbal.png')
// export const schoolFacebookPage = 'https://www.facebook.com/share/16kNUBvRRT/'
// export const colors = {
//     primary: '#013f72',
//     secondary: '#f6921e'
// }

// albayan
// export const logo = require('@/assets/img_app_logo.png')
// export const whiteLogo = require('@/assets/img_app_logo.png')
// export const schoolFacebookPage = 'https://www.facebook.com/share/14P1gkAAkdN/'
// export const colors = {
//     primary: '#000066',
//     secondary: '#f58634'
// }

// alnukhba
export const logo = require('@/assets/Alnukhba.png')
export const whiteLogo = require('@/assets/Alnukhba.png')
export const schoolFacebookPage = 'https://www.facebook.com/Alnukhbeh'
export const colors = {
    primary: '#80207f',
    secondary: '#81a42b'
}
